import { render, staticRenderFns } from "./FormuleValues.vue?vue&type=template&id=72031ea5"
import script from "./FormuleValues.vue?vue&type=script&lang=js"
export * from "./FormuleValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports